
  import { computed, defineComponent, ref } from 'vue';
  import { Box } from '@/ui/components/Box';
  import { Button } from '@/ui/components/Button';
  import { appliedForDiscount, fetchUser, getOrganizationUsersCount, user } from '@/ui/auth/auth';
  import {
    applyForDiscount,
    cancelSubscription,
    restoreSubscription,
  } from '@/services/api/resources/chargebee/subscription/actions';
  import { toasted } from '@/ui/helpers';
  import { t } from '@/ui/i18n/i18n';
  import SubscriptionModal from '@/ui/components/modals/subscriptions/SubscriptionModal.vue';
  import { isDiscountForChurnsEnabled } from '@/ui/helpers/featureHelper';

  export default defineComponent({
    name: 'CancelSubscription',
    components: { SubscriptionModal, Box, Button },
    setup() {
      const eligibleForAutomaticDiscount = 5;
      const csEmail = process.env.VUE_APP_CS_EMAIL;
      const submitting = ref(false);
      const showAcceptOfferModal = ref(false);
      const showDelightedModal = ref(false);
      const showGetOfferModal = ref(false);
      const showCancelModal = ref(false);

      const cancelled = computed(() => user.value.subscription?.isCancellationScheduled || false);

      const onCancelSubscriptionClick = () => {
        if (appliedForDiscount() || !isDiscountForChurnsEnabled()) {
          showCancelModal.value = true;

          return;
        }

        if (getOrganizationUsersCount() > eligibleForAutomaticDiscount) {
          showGetOfferModal.value = true;

          return;
        }

        showAcceptOfferModal.value = true;
      };

      const onReactivateClick = () => {
        submitting.value = true;

        restoreSubscription(user.value!.subscription!.id)()
          .then(() => {
            fetchUser()().then(() => {
              toasted.success(t('subscription.restored'));
              submitting.value = false;
            });
          });
      };

      const onAcceptOffer = () => {
        submitting.value = true;

        applyForDiscount(user.value!.subscription!.id)()
          .then(() => {
            fetchUser()().then(() => {
              showAcceptOfferModal.value = false;
              showDelightedModal.value = true;
              submitting.value = false;
            });
          });
      };

      const onCancelAnyway = () => {
        submitting.value = true;

        cancelSubscription(user.value!.subscription!.id)()
          .then(() => {
            fetchUser()().then(() => {
              showGetOfferModal.value = false;
              showAcceptOfferModal.value = false;
              showCancelModal.value = false;
              submitting.value = false;
            });
          });
      };

      const onAcceptOfferClose = () => {
        showAcceptOfferModal.value = false;
      };

      const onGetOfferClose = () => {
        showGetOfferModal.value = false;
      };

      const onDelightedClose = () => {
        showDelightedModal.value = false;
      };

      const onScheduleCall = () => {
        window.open(t('subscription.schedule-call'), '_blank');
        showGetOfferModal.value = false;
      };

      const onCancelClose = () => {
        showCancelModal.value = false;
      };

      return {
        csEmail,
        submitting,
        showAcceptOfferModal,
        showDelightedModal,
        showGetOfferModal,
        showCancelModal,
        cancelled,
        endsAt: user.value.subscription?.currentTermEnd,
        onCancelSubscriptionClick,
        onAcceptOffer,
        onCancelAnyway,
        onAcceptOfferClose,
        onScheduleCall,
        onGetOfferClose,
        onDelightedClose,
        onCancelClose,
        onReactivateClick,
      };
    },
  });
